/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { getEnvs } from "state/EnvironmentsContext/EnvContext";

const useDevAttributes = (fieldsObject) => {
  const { isDevelopment, isStaging } = getEnvs((state) => state);
  const attributes = {};
  if (fieldsObject) {
    Object.keys(fieldsObject).forEach((key) => {
      attributes[key] =
        isDevelopment || isStaging
          ? {
              "data-title": fieldsObject[key],
            }
          : {};
    });
  }

  return attributes;
};

export default useDevAttributes;

/*

  input => {
    "name": value,
    "name": value,
  }

  output => {
    name: {
      data-title: value
    }
  }
*/
